import { AnalyticsFilterState } from "@/core/entities/analytics/AnalyticsFilterState";
import { IAnalyticsFilterStateRepository } from "@/core/repositories/analyticsFilterState";

export class SaveAnalyticsFilterStateUseCase {
  constructor(private readonly repository: IAnalyticsFilterStateRepository) {}

  async execute(state: AnalyticsFilterState): Promise<void> {
    await this.repository.saveAnalyticsFilterState(state);
  }
}
